<template>
  <div class="min-h-[60px] rounded-sm bg-bg-danger-light px-5 py-2.5 flex items-center">
    <span class="mr-5">
      <icon
        class="icon"
        icon="exclamationCircle"
        color="text-color-danger"
        height="20"
        width="20"
      />
    </span>
    <p class="text-error-600">
      {{ text }}
      <span
        v-if="isResendButton"
        class="text-primary-purple-700 cursor-pointer"
        @click="$emit('resendEmail')"
      >
        Resend Verification Email
      </span>
    </p>
  </div>
</template>

<script>
import icon from '@components/icons/icon.vue'

export default {
  components: {
    icon,
  },
  props: { text: { type: String, default: '' }, isResendButton: { type: Boolean, default: false } },
  emits: ['resendEmail'],
  methods: {},
}
</script>

<style lang="scss">
@import '@src/design/_mediaquery-mixin.scss';
</style>
